export function getBrandLogoSrc(brand: string): string {
  return `/img/brands/${brand.toLowerCase()}.png`;
}

export function handleBrandLogoError(
  e: React.SyntheticEvent<HTMLImageElement, Event>,
  brand: string,
) {
  const img = e.currentTarget;
  const svgSrc = `/img/brands/${brand.toLowerCase()}.svg`;
  if (!img.src.endsWith(".svg")) {
    img.src = svgSrc;
    return;
  }
  img.style.display = "none";
}
